var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"btn-style":"primary","name":"phone-call","color":"none","size":12},nativeOn:{"click":function($event){return _vm.openDialog.apply(null, arguments)}}},[_vm._v("\n  ¡Te llamamos!\n")])}
var staticRenderFns = []

export { render, staticRenderFns }